import { Controller } from "@hotwired/stimulus";
import {
  spreadsheetMangledPhones,
  SPREADSHEET_CORRUPTION_MESSAGE,
} from "../csv_quality";

// CSV import card: gates the submit on a chosen file and renders a
// client-side preview of the first rows so the operator can sanity-check
// columns before importing. The file-choosing UX lives in the shared
// dropzone controller — this listens for its dropzone:changed and
// dropzone:cleared events. Connects to data-controller="csv-upload".
export default class extends Controller {
  static targets = ["preview", "previewHead", "previewBody", "submit", "error"];

  static PREVIEW_ROWS = 4;

  connect() {
    this.submitTarget.disabled = true;
  }

  fileChosen({ detail: { file } }) {
    // The preview parse decides whether the submit unlocks.
    this.renderPreview(file);
  }

  cleared() {
    this.previewTarget.classList.add("hidden");
    this.errorTarget.classList.add("hidden");
    this.submitTarget.disabled = true;
  }

  renderPreview(file) {
    const reader = new FileReader();
    reader.onload = () => {
      const lines = reader.result
        .split(/\r?\n/)
        .filter((line) => line.trim().length > 0);
      if (lines.length === 0) return;

      const parse = (line) =>
        line.split(",").map((cell) => cell.trim().replace(/^"|"$/g, ""));
      const header = parse(lines[0]);
      const allRows = lines.slice(1).map(parse);
      const rows = allRows.slice(0, this.constructor.PREVIEW_ROWS);

      const corrupted = spreadsheetMangledPhones(header, allRows);
      this.errorTarget.textContent = corrupted
        ? SPREADSHEET_CORRUPTION_MESSAGE
        : "";
      this.errorTarget.classList.toggle("hidden", !corrupted);
      this.submitTarget.disabled = corrupted;

      this.previewHeadTarget.innerHTML = "";
      header.forEach((cell) => {
        const th = document.createElement("th");
        th.className = "table-th";
        th.textContent = cell;
        this.previewHeadTarget.appendChild(th);
      });

      this.previewBodyTarget.innerHTML = "";
      rows.forEach((cells) => {
        const tr = document.createElement("tr");
        tr.className = "table-row";
        header.forEach((_, i) => {
          const td = document.createElement("td");
          td.className = "table-td font-mono text-xs";
          td.textContent = cells[i] || "";
          tr.appendChild(td);
        });
        this.previewBodyTarget.appendChild(tr);
      });

      const more = lines.length - 1 - rows.length;
      this.previewTarget.querySelector("[data-csv-upload-more]").textContent =
        more > 0
          ? `+ ${more.toLocaleString()} more row${more === 1 ? "" : "s"}`
          : "";
      this.previewTarget.classList.remove("hidden");
    };
    reader.readAsText(file.slice(0, 64 * 1024));
  }
}
